module.exports = __webpack_public_path__ + "img/mask-down.4226977d.png";